import { createPortal } from "react-dom";
import { useMention } from "../context/MentionContext";
import { useTheme } from "@emotion/react";
const MentionDropdown = () => {
  const { suggestions, showDropdown, addMention, dropdownPos } = useMention();
  const theme = useTheme();
  if (
    !showDropdown ||
    suggestions.length === 0 ||
    !dropdownPos ||
    dropdownPos.top === undefined
  ) {
    return null;
  }

  return createPortal(
    <div
      style={{
        position: "absolute",
        top: dropdownPos.top,
        left: dropdownPos.left,
        width: dropdownPos.width || 260,
        background:  theme.palette.mode === "dark" ? "#333" : "#f9f9f9",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        maxHeight: "200px",
        overflowY: "auto",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        zIndex: 9999,
      }}
    >
      {suggestions.map((user) => (
        <div
          key={user._id}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => addMention(user)}
          style={{
            padding: "10px 14px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          @{user.username || user.name}
        </div>
      ))}
    </div>,
    document.body
  );
};

export default MentionDropdown;
